'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getLocationAndSubsection = undefined;

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _dayjs = require('dayjs');

var _dayjs2 = _interopRequireDefault(_dayjs);

var _timezone = require('dayjs/plugin/timezone');

var _timezone2 = _interopRequireDefault(_timezone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-console */
_dayjs2.default.extend(_timezone2.default);

// The whole logic is based on the requirements in the table from ticket JP-8435
var getLocationAndSubsection = exports.getLocationAndSubsection = function getLocationAndSubsection() {
    var path = window.location.pathname;

    var ukTimeZone = 'Europe/London';
    var today = (0, _dayjs2.default)().tz(ukTimeZone).format('YYYY-MM-DD');
    var tomorrow = (0, _dayjs2.default)().add(1, 'day').tz(ukTimeZone).format('YYYY-MM-DD');
    var yesterday = (0, _dayjs2.default)().subtract(1, 'day').tz(ukTimeZone).format('YYYY-MM-DD');

    // we use includes(), because URL might not end with trailing slash
    // and we can't predict it in advance
    if (path === '/racecards/' || path === '/racecards') {
        return { location: 'Racing Today', subsection: 'Racecards Races Course' };
    } else if (path.includes('/racecards/time-order')) {
        return { location: 'Racing Today', subsection: "Today's Racecards Races Time" };
    } else if (path.includes('/racecards/runners-index')) {
        return { location: 'Racing Today', subsection: "Today's Racecards Runners Index" };
    } else if (path.includes('/racecards/' + today + '/stable-tour')) {
        return { location: 'Racing Today', subsection: 'Today\'s Racecards Stable Tours Entries' };
    } else if (path === '/racecards/tomorrow' || path === '/racecards/tomorrow/' || path === '/racecards/' + tomorrow) {
        return { location: 'Racing Races', subsection: "Tomorrow's Racecards Races Course" };
    } else if (path.includes('/racecards/' + tomorrow + '/time-order') || path.includes('/racecards/tomorrow/time-order')) {
        return { location: 'Racing Races', subsection: 'Tomorrow\'s Racecards Races Time' };
    } else if (path.includes('/racecards/' + tomorrow + '/runners-index')) {
        return { location: 'Racing Races', subsection: 'Tomorrow\'s Racecards Runners Index' };
    } else if (path.includes('/racecards/' + tomorrow + '/stable-tour')) {
        return { location: 'Racing Races', subsection: 'Tomorrow\'s Racecards Stable Tours Entries' };
    } else if (path.includes('/racecards/big-race-entries')) {
        return { location: 'Racing Races', subsection: 'Big Race Entries' };
    } else if (path.includes('/racecards/us-racing')) {
        return { location: 'Racing Races', subsection: 'US Racing' };
    }
    // cases for URLs with raceId and future dates
    else if (path.startsWith('/racecards/')) {
            var splittedPath = path.split('/');

            if (splittedPath.length <= 4) {
                var date = splittedPath[2];

                if (path.includes('/time-order')) {
                    return {
                        location: 'Racing Races',
                        subsection: 'Racecards ' + (0, _dayjs2.default)(date).format('DD MMMM YYYY') + ' Races Time'
                    };
                } else if (path.includes('/runners-index')) {
                    return {
                        location: 'Racing Races',
                        subsection: 'Racecards ' + (0, _dayjs2.default)(date).format('DD MMMM YYYY') + ' Runners Index'
                    };
                } else if (path.includes('/stable-tour')) {
                    return {
                        location: 'Racing Races',
                        subsection: 'Racecards ' + (0, _dayjs2.default)(date).format('DD MMMM YYYY') + ' Stable Tours Entries'
                    };
                }

                return {
                    location: 'Racing Races',
                    subsection: 'Racecards ' + (0, _dayjs2.default)(date).format('DD MMMM YYYY') + ' Races Course'
                };
            } else {
                if (path.includes('/pro')) {
                    return { location: 'Racecards', subsection: 'Pro' };
                } else if (path.includes('/at-a-glance')) {
                    return { location: 'Racecards', subsection: 'At-a-glance' };
                } else if (path.includes('/odds-comparison')) {
                    return { location: 'Racecards', subsection: 'Odds Comparison' };
                } else if (path.includes('/raceday-live')) {
                    return { location: 'Racecards', subsection: 'Raceday Live' };
                }

                return {
                    location: 'Racecards',
                    subsection: 'Standard'
                };
            }
            // cases for results pages and past dates
        } else if (path === '/results' || path === '/results/') {
            return { location: 'Racing Results', subsection: 'Racing Results Course' };
        } else if (path === '/fast-results' || path === '/fast-results/') {
            return { location: 'Racing Results', subsection: 'Fast Results Time' };
        } else if (path === '/results/' + yesterday || path === '/results/' + yesterday + '/') {
            return { location: 'Racing Results', subsection: 'Yesterday\'s Results Course' };
        } else if (path.includes('/results/time-order')) {
            return { location: 'Racing Results', subsection: 'Yesterday\'s Results Time' };
        } else if (path === '/results/' + yesterday + '/time-order' || path === '/results/' + yesterday + '/time-order/') {
            return { location: 'Racing Results', subsection: 'Yesterday\'s Results Time' };
        } else if (path.startsWith('/results/')) {
            var _splittedPath = path.split('/');
            var _date = _splittedPath[2];
            var isDateBeforeYesterday = (0, _dayjs2.default)(_date).isBefore((0, _dayjs2.default)(yesterday));

            if (isDateBeforeYesterday && path.includes('/time-order')) {
                return {
                    location: 'Racing Results',
                    subsection: 'Results ' + (0, _dayjs2.default)(_date).format('DD MMMM YYYY') + ' Time'
                };
            } else if (isDateBeforeYesterday) {
                return {
                    location: 'Racing Results',
                    subsection: 'Results ' + (0, _dayjs2.default)(_date).format('DD MMMM YYYY') + ' Course'
                };
            } else {
                return {
                    location: 'Racing Results',
                    subsection: 'N/A'
                };
            }
            // cases for news and horse tracker
        } else if (path === '/news/live' || path === '/news/live/') {
            return { location: 'Raceday Live', subsection: 'N/A' };
        } else if (path === '/horse-tracker' || path === '/horse-tracker/') {
            return { location: 'Horse Tracker', subsection: 'Entries' };
        } else if (path.includes('/horse-tracker/tracked')) {
            return { location: 'Horse Tracker', subsection: 'Tracked' };
        } else if (path.includes('/horse-tracker/settings')) {
            return { location: 'Horse Tracker', subsection: 'Settings' };
        }
        // cases for horse profiles
        else if (path.startsWith('/profile/')) {
                // Case for horse profiles
                if (path.includes('/horse/')) {
                    var subsectionMap = {
                        '/form': 'Form',
                        '/entries': 'Entries',
                        '/stats': 'Stats',
                        '/quotes': 'Quotes',
                        '/pedigree': 'Pedigree',
                        '/sales': 'Sales',
                        '/notes': 'Notes'
                    };

                    var subsection = Object.keys(subsectionMap).find(function (key) {
                        return path.includes(key);
                    }) || 'N/A';
                    return { location: 'Horse Profile', subsection: subsectionMap[subsection] };
                }

                // Cases for trainer, jockey, and owner profiles
                var profileTypes = { trainer: 'Trainers', jockey: 'Jockeys', owner: 'Owners' };
                var matched = Object.entries(profileTypes).find(function (_ref) {
                    var _ref2 = (0, _slicedToArray3.default)(_ref, 1),
                        type = _ref2[0];

                    return path.startsWith('/profile/' + type + '/');
                });

                if (matched) {
                    var _subsection = matched[1];
                    return { location: 'Profiles', subsection: _subsection };
                }
            }
            // case for my bookmakers page
            else if (path.includes('/my-bookmakers')) {
                    return { location: 'My Bookmakers', subsection: 'N/A' };
                } else if (path.includes('/subscriptions/my-account')) {
                    return { location: 'Members Club', subsection: 'My Account' };
                }

    // in case there is no match
    return { location: 'Unknown', subsection: 'Unknown' };
};


//////////////////
// WEBPACK FOOTER
// ./~/rp-analytics/lib/utils/getLocationAndSubsection.js
// module id = 1829
// module chunks = 0